import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/uiKit/atoms/Button.tsx';
import { CardFooter } from '@/uiKit/atoms/card/CardFooter.tsx';
import {
  CarePlanCreationInfoWithPrescription,
  SimpleCarePlanCreationInfo,
} from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanCreation.ts';
import { CARE_PLAN_CREATION_FORM_ID } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanCreationForm.tsx';

export type CarePlanCreationFormActionsProps = {
  onBack?: (data: Partial<CarePlanCreationInfoWithPrescription>) => void;
};

export const CarePlanCreationFormActions: React.FC<
  CarePlanCreationFormActionsProps
> = ({ onBack }) => {
  const formContext = useFormContext<SimpleCarePlanCreationInfo>();
  const { t } = useTranslation();
  const diabetesType = useWatch<SimpleCarePlanCreationInfo, 'diabetesType'>({
    name: 'diabetesType',
  });
  const insulinScheme = useWatch<SimpleCarePlanCreationInfo, 'insulinScheme'>({
    name: 'insulinScheme',
  });

  return (
    <CardFooter>
      <Button
        variant="outlined"
        id="care-plan-creation-cancel"
        onClick={() =>
          onBack &&
          onBack(
            formContext.getValues() as CarePlanCreationInfoWithPrescription,
          )
        }
      >
        {t('button.back')}
      </Button>
      <Button
        form={CARE_PLAN_CREATION_FORM_ID}
        id="care-plan-creation-next"
        type="submit"
        variant="contained"
      >
        {t(
          diabetesType === 'gestational' && insulinScheme === 'noInsulin'
            ? 'diabetesForms.addPatient'
            : 'button.next',
        )}
      </Button>
    </CardFooter>
  );
};
